import { format } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';

import ModalActions from 'components/task-item-ecoa/modal-actions';

import { ModeloDaAcaoEcoa } from '../andamento-da-acao';

export const FALHA_NA_ACAO = 'Não foi possível concluir. Tente novamente.';

/** "3 out. 26": data de cadastro e de atualização nos cartões. */
export function dataCurta(ms: number): string {
  return format(new Date(ms), 'd MMM. yy', { locale: ptBR });
}

/** Os modais do `TaskItemEcoa` (ECN-57) com as props que o hook calcula; iguais nos três cartões. */
export function ModaisDaAcaoEcoa({ modelo }: { modelo: ModeloDaAcaoEcoa }) {
  return (
    <ModalActions
      callback={modelo.callBackActions}
      id={modelo.data._id}
      status={modelo.status}
      data={modelo.data}
      playerInfo={modelo.playerInfo}
      validateTeamMember={modelo.validateTeamMember}
      activeEvaluationStep={modelo.activeEvaluationStep as number}
      bonus={modelo.bonus}
      userToChange={modelo.userToChange}
      ecoa={modelo.ecoa}
    />
  );
}
